"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CardContainer", {
  enumerable: true,
  get: function get() {
    return _$previous.CardContainer;
  }
});
exports.default = void 0;

var _$previous = babelHelpers.interopRequireWildcard(require("$previous"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _decorators = require("decorators");

var _trackObjectView = babelHelpers.interopRequireDefault(require("trackObjectView"));

var _noty = require("noty");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _descriptor2, _temp;

var LinkListBlock = (_class = (_temp =
/*#__PURE__*/
function (_BaseLinkListBlock) {
  babelHelpers.inherits(LinkListBlock, _BaseLinkListBlock);

  function LinkListBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LinkListBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LinkListBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "catalogAppId", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "pluginId", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(LinkListBlock, [{
    key: "getChildren",
    value: function getChildren() {
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(LinkListBlock.prototype), "getChildren", this).call(this);
      return _react.default.createElement(r.type, Object.assign({
        onClick: this.onClick,
        key: r.key,
        ref: r.ref
      }, r.props));
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var tgt = event.target;

      do {
        if (tgt.nodeName.toLowerCase() == 'a' && 'showDocument' in tgt.dataset && tgt.dataset.access == 'enabled') {
          this.handlePdfLink(tgt);
          event.preventDefault();
          return;
        }

        tgt = tgt.parentNode;
      } while (tgt != document.body);
    }
  }, {
    key: "handlePdfLink",
    value: function handlePdfLink(target) {
      var _this2 = this;

      var D = JSON.parse(target.dataset.pdfOptions);
      var tgt;

      if (!D || !D.pdf) {
        tgt = window.open('about:blank', '_blank');
      }

      (0, _fetch.default)("access/" + this.catalogAppId + "/" + target.dataset.showDocument).then(function (result) {
        return result.json();
      }).then(function (data) {
        if (data.access == 'enabled') {
          require('trackObjectView').default('catalog', target.dataset.showDocument, true);

          if (tgt) {
            tgt.location.href = data.detail.signedDocumentURL;
          } else {
            var opt = {};
            opt.toolbar = !!D.toolbar;
            opt.file = data.detail.signedDocumentURL;
            opt.controls = Object.keys(D.toolbar).filter(function (v) {
              return D.toolbar[v];
            }).join(",");
            if (data.detail.password) opt.password = data.detail.password;
            var optString = Object.keys(opt).map(function (key) {
              return [key, opt[key]].map(encodeURIComponent).join('=');
            }).join('&');
            var f = document.createElement('div');
            f.id = 'document-viewer-modal-wrap';
            f.className = 'modal-wrapper fade';
            f.innerHTML = ['<div class="modal modal-full modal-full-align-top fade" id="document-viewer-modal" role="dialog" tabindex="-1" aria-hidden="true" data-backdrop-parent="#document-viewer-modal-wrap">', '<div class="modal-dialog">', '<div class="modal-content">', '<div class="modal-header">', BLX.modalCloseButton(), '<h4 class="modal-title">', '<span class="material-icons" data-icon="insert_drive_file"></span>', 'Document', '</h4>', '</div>', '<div class="modal-body">', '<iframe id="document-viewer"></iframe>', '</div>', '</div>', '</div>', '</div>'].join('');
            f.querySelector('iframe').src = '/admin/platform/plugins/' + _this2.pluginId + '/libraries/pdf.js/web/viewer.html?' + optString;
            document.body.appendChild(f);
            $(f.querySelector('.modal')).on('hidden.bs.modal', function () {
              $(f).remove();
            }).modal('show');
          }
        } else {
          if (tgt) tgt.close();
          (0, _noty.showNotificationText)("You do not have permission to view that resource.", "danger", "warning");
        }
      });
    }
  }]);
  return LinkListBlock;
}(_$previous.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogAppId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "pluginId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "onClick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class);
exports.default = LinkListBlock;